module.exports = __webpack_public_path__ + "static/media/group-left.0a37ec6d.jpeg";